<template>
  <v-container fluid>
    <v-row class="d-flex align-center justify-center mb-7">
      <v-img max-height="63px" contain src="https://www.clipartmax.com/png/full/164-1645237_laurel-crown-3-laurel-award.png"/>
    </v-row>
    <v-row align="center" justify="center">
      <h2 class="text-center px-2">Lo mejor de la industria del trading e inversiones en un sólo lugar.</h2>
    </v-row>
    <v-row align="center" justify="center">
      <p class="text-center mt-3 px-2">Celebramos la excelencia individual y en equipo tanto de Traders como de Academias y Brokers.</p>
    </v-row>
    <v-divider class="my-7"/>
    <v-row align="center" justify="center">
      <!--div>
        <h1>Votaciones Cerradas</h1>
        <h2 style="color: #312860" class="text-center">¡Pronto sabrás los ganadores!</h2>
      </div!-->
      <v-btn class="main-button" @click="goToAwardCategories" large>
        <v-icon class="mr-2" small>fa-medal</v-icon> Vota por tus Favoritos »
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VoteHome",
  data() {
    return {
      categories: [],
    };
  },
  methods: {
    goToAwardCategories() {
      this.$router.push('/vote/award-categories');
    },
  }
}
</script>

<style scoped>
.main-button {
  background-color: #312860 !important;
  color: #00F784 !important;
}
</style>
